import { useEffect, useRef, useState } from "react"
import { useLocation, Link } from "react-router-dom"
import { scrollWithOffset } from "../components/scrollWithOffSet"

import "./home.css"

import Gallery from "../components/gallery"
import CommentaryForm from "../components/commentaryForm"
import CommentaryList from "../components/commentaryList"

import eduardo from "../../assets/general_assets/jiu-jitsu-photos/eduardo.jpg"
import event1 from "../../assets/general_assets/event1.jpg"

import retriet1 from "../../assets/general_assets/retriet1.png"
import retriet2 from "../../assets/general_assets/retriet2.png"
import retriet3 from "../../assets/general_assets/retriet3.png"
import retriet4 from "../../assets/general_assets/retriet4.png"
import retriet5 from "../../assets/general_assets/retriet5.png"
import retriet6 from "../../assets/general_assets/retriet6.png"
import retriet7 from "../../assets/general_assets/retriet7.png"

import cook from "../../assets/general_assets/jiu-jitsu-photos/IMG_6879 - Copy.jpg"
import group from "../../assets/general_assets/jiu-jitsu-photos/IMG_7250.jpg"
import practice from "../../assets/general_assets/jiu-jitsu-photos/IMG_7201 2.jpg"
import view from "../../assets/general_assets/jiu-jitsu-photos/IMG_7223 2.jpg"

import logo from "../../assets/general_assets/Transparent logo.png"
import rosa from "../../assets/general_assets/rosadosventos2.png"


export default function Home() {

    const location = useLocation()

    const eventRef = useRef(null)

    //const [imgAtual, setImgAtual] = useState(3)
    const [commentaries, setCommentaries] = useState(() => {
        try {
            const saved = localStorage.getItem('commentaries');
            return saved ? JSON.parse(saved) : [];
        } catch (error) {
            alert("Não foi possível carregar os comentários")
            return []
        }
    })

    //const houseImgs = [
    //    retriet1,
    //    retriet2,
    //    retriet3,
    //    retriet4,
    //    retriet5,
    //    retriet6,
    //    retriet7,
    //]

    const homeTitle = useRef(null);
    const homeSubTitle = useRef(null);
    const aboutUsRef = useRef(null);
    const aboutUsLogoRef = useRef(null);
    const ceoRef = useRef(null);
    const ceoLogoRef = useRef(null);
    const homeImage = useRef(null);
    //function nextImg() {
    //    const newIndex = (imgAtual + 1) % houseImgs.length;
    //    setImgAtual(newIndex);
    //}
    //
    //function prevImg() {
    //    const newIndex = (imgAtual - 1 + houseImgs.length) % houseImgs.length;
    //    setImgAtual(newIndex);
    //}

    // INTEGRAR COM O BACK-END FUTURAMENTE
    //const addCommentary = (newText) => {
    //    const now = new Date;
    //    const userName = "Eduardo"
    //    const formatDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
//
    //    const newCommentary = {
    //        name: userName,
    //        text: newText,
    //        date: formatDate
    //    }
//
//
    //    setCommentaries([...commentaries, newCommentary])
//
    //}

    const eventSize = (e) => {

        if (window.innerWidth > 768) {


            e.preventDefault();
            e.stopPropagation();

            const overlay = document.getElementById('overlay');

            if (eventRef.current && overlay) {
                if (!eventRef.current.classList.contains("expand")) {
                    eventRef.current.classList.add("expand");
                    overlay.classList.add('active');
                } else {
                    eventRef.current.classList.remove("expand");
                    overlay.classList.remove('active');
                }
            }
        } else {
            window.open("/graucanaria.jpg", "_blank");
        }

    }

    const reduceEvent = () => {
        const overlay = document.getElementById('overlay');

        if (eventRef.current && overlay) {
            if (eventRef?.current.classList.contains("expand")) {
                eventRef.current.classList.remove("expand");
                overlay.classList.remove('active');
            }
        }
    }

    useEffect(() => {
        window.addEventListener("click", reduceEvent);
        window.addEventListener("scroll", reduceEvent);

        return () => {
            window.removeEventListener("click", reduceEvent);
            window.removeEventListener("scroll", reduceEvent);
        }
    }, [])
    
    
    
    useEffect(() => {
        localStorage.setItem("commentaries", JSON.stringify(commentaries));
    }, [commentaries])
    
    useEffect(() => {
        const handleAnimation = () => {
            if (window.scrollY > 50) {
                homeTitle.current.style.animation = "fadeOutTitle 1s ease forwards";
                homeSubTitle.current.style.animation = "fadeOutSubTitle 1s ease forwards";
                homeImage.current.style.setProperty("--overlay-opacity","0")
            } else {
                homeTitle.current.style.animation = "fadeInTitle 1s ease forwards";
                homeSubTitle.current.style.animation = "fadeInSubTitle 1.5s ease 1s forwards";
                homeImage.current.style.setProperty("--overlay-opacity","0.4")

            }

        }

        handleAnimation();
        window.addEventListener("scroll", handleAnimation);
 
        return () => {
            window.removeEventListener("scroll", handleAnimation);


        }
    }, [location])
    

    useEffect(() => {
        const observerAboutUs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    aboutUsRef.current.classList.add("fade-in")
                    aboutUsLogoRef.current.classList.add("fade-in")
                }

            },
            {
                threshold: 0.01,

            }
        );

        const observerCeo = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    ceoRef.current.classList.add("fade-in")
                    ceoLogoRef.current.classList.add("fade-in")
                }

            },
            {
                threshold: 0.01,

            }
        );

        if (aboutUsRef.current) observerAboutUs.observe(aboutUsRef.current);
        if (ceoRef.current) observerCeo.observe(ceoRef.current);

        return () => {
            if (aboutUsRef.current) observerAboutUs.unobserve(aboutUsRef.current);
            if (ceoRef.current) observerCeo.unobserve(ceoRef.current);
        };
    }, []);

    useEffect(() => {

        if (location.state?.scrollTo === "aboutus") {
            const aboutUs = document.getElementById("aboutUs");
            scrollWithOffset(aboutUs, 100)

        } else if (location.state?.scrollTo === "events") {
            const events = document.getElementById("events");
            scrollWithOffset(events, 100)

        }

    }, [location])


    return (

        <>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"></link>
            <main>
                <div id="overlay" className="overlay"></div>
                <div ref={homeImage} className="homeImage">
                    <p ref={homeTitle} className="homeImageTitle" >WELCOME TO NOMADIC WAY</p>
                    <p ref={homeSubTitle} className="homeImageSubTitle" >"Jiu-Jitsu is the art of making friends"</p>
                </div>

                <section>

                    <article id="aboutUs" ref={aboutUsRef} className="company_info">
                        <div className="company_info_text">
                            <h2>About Eduardo & Nomadic Way</h2>
                            <p >
                                With nearly 25 years of experience in Brazilian Jiu Jitsu, Eduardo’s journey has taken him across the globe — training with and learning from some of the most respected practitioners in the art.
                                After many years living and training in the UK, Eduardo returned to Brazil to continue his development under Master Claudio Arrais, a 6th-degree black belt under Rilion Gracie. In 2014, Eduardo was awarded his black belt — a milestone earned through dedication, discipline, and a deep respect for the Gentle Art.
                                In 2016, Eduardo was invited to the United Arab Emirates, where he played a key role in developing the national BJJ program. For six years, he served as the Head Instructor for the UAE Air Force, while also teaching the UAE Armed Forces, Abu Dhabi Police Academy, and military universities across the region. His focus on fundamentals, body mechanics, and self-defense has shaped his teaching style into one that is precise, accessible, and rooted in tradition.
                                A regular contributor to seminars worldwide, Eduardo continues to learn and share with communities across the UK and beyond — always refining his craft while passing it forward.
                                Now based back in the UK, Eduardo has launched Nomadic Way — a unique Jiu Jitsu retreat experience born from his passion for travel, connection, and the art of BJJ.
                                More than just training camps, Nomadic Way retreats are immersive journeys designed for like-minded people to roll, explore, and live the Jiu Jitsu lifestyle — surrounded by nature, community, and purpose.
                                
                            </p>
                            <p style={{marginTop:"auto", fontStyle:"italic", textAlign:"center"}}>Train. Travel. Connect. This is the Nomadic Way.</p>
                            <img ref={aboutUsLogoRef} alt="Nomadic Way logo" src={logo} />
                        </div>
                        <img className="company_info_img" alt="Nomadic Way Founder" src={eduardo} />

                    </article>

                    {

                        //<article id="retreat" ref={ceoRef} className="company_info inverted">
                        //    <div className="company_info_text inverted">
                        //        <h2>Meet Our Retreat</h2>
                        //        <p>
                        //            The Retreat is a place where you can feel incredibly relaxed and enjoy the space by practicing Jiu-Jitsu, eating great food, and spending time making new friends.
                        //        </p>
                        //
                        //        <img ref={ceoLogoRef} alt="Nomadic Way Logo" src={logo} />
                        //    </div>
                        //    <div style={{ position: "relative" }}>
                        //
                        //        <img className="company_info_img" alt="Nomadic Way Retreat" src={houseImgs[imgAtual]} />
                        //        <i onClick={prevImg} id="left" class="bi bi-arrow-left-circle"></i>
                        //        <i onClick={nextImg} id="right" class="bi bi-arrow-right-circle"></i>
                        //
                        //    </div>
                        //
                        //</article>
                    }
                </section>

                <Gallery />
                <section>
                    <div className="gallery-container inverted">

                        <img className="gallery-logo" alt="Nomadic Way Logo" src={rosa} />
                        <div id="roundImg1">
                            <h2 className="roundImg_tile">Connect</h2>
                            <p className="roundImg_text">Meet people from around the world and build lasting friendships through Jiu-Jitsu. </p>
                        </div>
                        <div id="roundImg2" >
                            <h2 className="roundImg_tile">Train</h2>
                            <p className="roundImg_text">Train daily with partners of all levels in a unique and inspiring setting.</p>
                        </div>
                        <div id="roundImg3" >
                            <h2 className="roundImg_tile">Travel</h2>
                            <p className="roundImg_text">Travel to stunning landscapes around the world</p>
                        </div>
                        <div id="roundImg4" >
                            <h2 className="roundImg_tile">Eat</h2>
                            <p className="roundImg_text">Recharge with fresh, delicious food prepared by a professional Chef</p>
                        </div>


                        <div className="round">
                            <img id="rosa-img1" alt="Nomadic Way" src={group} />
                            <img id="rosa-img2" alt="Nomadic Way" src={practice} />
                            <img id="rosa-img3" alt="Nomadic Way" src={view} />
                            <img id="rosa-img4" alt="Nomadic Way" src={cook} />
                        </div>

                    </div>
                </section>

                <section>

                    <div id="events" className="events_info">

                        <h2>Upcoming Events </h2>
                        <button style={{display:"none"}} id="EventButton" className="buyButton">
                            Buy Tickets
                        </button>

                        <div className="event_cards_container">
                            <div ref={eventRef} onClick={eventSize} className="event_card_wrapper">
                                <img className="event_card" alt="Nomadic Way Event" src={event1} />
                            </div>

                        </div>
                    </div>

                </section>
                <section>
                    <article className="comentary_info">

                        <CommentaryList commentaries={commentaries} />
                        `{/*<CommentaryForm />*/}
                        <p style={{fontSize:"30px",color:"white"}}>Commentary section coming soon...</p>

                    </article>
                </section>

            </main>
        </>

    )

}